import { Link } from 'react-router-dom';
import { getCurrentYear } from '../../helper/helper';

const Footer = ({ className }: { className?: string }) => {
  return (
    <div
      className={
        className
          ? `${className} flex flex-col gap-1 bg-white my-4 pl-[1rem] `
          : 'max-w-7xl flex flex-col gap-1 bg-white my-4 pl-[1rem]'
      }
    >
      <div className="flex flex-col items-start gap-[.25rem] ">
        <strong className="text-storyblue text-xs md:text-sm mx-0 ">BuildMyStory © {getCurrentYear()}</strong>
        <div className=" flex flex-col md:flex-row items-start gap-4">
          <Link
            className="bg-transparent text-[#c0bab0] font-medium duration-500 hover:duration-5000 hover:text-[#61cbb7] hover:font-bold text-sm "
            to="https://buildmystory.com/terms-and-conditions/"
            target="_blank"
          >
            Terms of Service
          </Link>
          <Link
            className="bg-transparent text-[#c0bab0] font-medium duration-500 hover:duration-5000 hover:text-[#61cbb7] hover:font-bold text-sm "
            to="https://buildmystory.com/privacy-policy/"
            target="_blank"
          >
            Confidentiality Policy
          </Link>
          <Link
            to="https://buildmystory.com/cookie-policy/"
            target="_blank"
            className="bg-transparent text-[#c0bab0] font-medium duration-500 hover:duration-5000 hover:text-[#61cbb7] hover:font-bold text-sm "
          >
            Cookies
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Footer;
